import React from 'react';
import { css } from '@emotion/react';
import PropTypes from 'prop-types';

import { Checkbox } from '../lumen/components';

export default function SendEmailSelector({
  email,
  checked,
  onChange,
  additionalCss
}) {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        align-items: center;
        ${additionalCss}
      `}
    >
      <Checkbox
        checked={checked}
        onChange={evt => onChange(evt.target.checked)}
        label={`E-mail ${email} when the project is ready`}
      />
    </div>
  );
}

SendEmailSelector.propTypes = {
  email: PropTypes.any.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  additionalCss: PropTypes.object
};
